module.exports = new __parcel__URL__("fox.c1068dfa.svg").toString();